/** Словарь главных страниц (ru) */
export default {
  loadError: "Не удалось загрузить главную страницу.",
  greeting: { morning: "Доброе утро, {{name}}", afternoon: "Добрый день, {{name}}", evening: "Добрый вечер, {{name}}" },
  eyebrow: "{{date}} · Ташкент {{tashkent}} · Даллас {{dallas}}",
  eyebrowShort: "{{date}} · Ташкент {{tashkent}}",
  callOpen: "В Далласе {{time}} — время звонков, осталось {{left}}",
  callClosed: "В Далласе {{time}} — время звонков начнётся в {{at}}, через {{wait}}",
  overdue_one: "{{count}} просрочена",
  overdue_few: "{{count}} просрочены",
  overdue_many: "{{count}} просрочено",
  overdue_other: "{{count}} просрочено",
  nothingOverdue: "просроченных нет",
  addDriver: "Добавить водителя",
  kpi: {
    newDrivers: "Новые водители",
    submitted: "Отправлено перевозчикам",
    waiting_one: "{{count}} ждёт",
    waiting_few: "{{count}} ждут",
    waiting_many: "{{count}} ждут",
    waiting_other: "{{count}} ждут",
    forReply: "ответа перевозчика",
    hired: "Нанято",
    pending_one: "{{count}} ждёт подтверждения",
    pending_few: "{{count}} ждут подтверждения",
    pending_many: "{{count}} ждут подтверждения",
    pending_other: "{{count}} ждут подтверждения",
    approved: "подтверждено менеджером",
    myBonus: "Мой бонус",
    estimate: "Оценка",
    finalAfter: "итог после подтверждения",
    hires: "Наймы",
    inPipeline: "В воронке",
    submittedN_one: "{{count}} отправлен",
    submittedN_few: "{{count}} отправлено",
    submittedN_many: "{{count}} отправлено",
    submittedN_other: "{{count}} отправлено",
    thisMonth: "в этом месяце",
    profit: "Прибыль",
    noFees: "Оплат пока нет",
    moneyNote: "получено {{received}} · расходы {{cost}}",
    costPerHire: "Стоимость найма",
    costNote: "расходы + зарплаты + бонусы",
    avgTime: "Среднее время найма",
    retentionChip: "{{pct}} удержание",
    retentionNote: "30 дней, наймы старше 30 дней",
    vs: "к {{month}}",
    prevIn: "{{count}} в {{month}}",
    noPrev: "нет данных за {{month}}",
    same: "как в {{month}}",
  },
  today: {
    title: "Сегодня",
    overdue_one: "{{count}} просрочена",
    overdue_few: "{{count}} просрочены",
    overdue_many: "{{count}} просрочено",
    overdue_other: "{{count}} просрочено",
    dueToday_one: "{{count}} сегодня",
    dueToday_few: "{{count}} сегодня",
    dueToday_many: "{{count}} сегодня",
    dueToday_other: "{{count}} сегодня",
    tomorrow_one: "{{count}} завтра",
    tomorrow_few: "{{count}} завтра",
    tomorrow_many: "{{count}} завтра",
    tomorrow_other: "{{count}} завтра",
    all: "Все задачи",
    empty: "На сегодня ничего нет. Отлично.",
    markDone: "Отметить выполненной",
    snooze: "Завтра 9:00",
    call: "Позвонить",
    yours_one: "ваш {{count}} водитель",
    yours_few: "ваши {{count}} водителя",
    yours_many: "ваши {{count}} водителей",
    yours_other: "ваши {{count}} водителя",
    doneFailed: "Не удалось отметить задачу выполненной",
    snoozed: "Отложено до завтра 9:00",
  },
  due: { yesterday: "Вчера", today: "Сегодня", tomorrow: "Завтра", overdue: "Просрочено" },
  attention: {
    trucks: "траков: страховка или инспекция в течение {{days}} дней",
    title: "Требует внимания",
    live: "Онлайн",
    noContact: "без контакта {{days}}+ дней",
    waitingDocs: "не хватает обязательных документов",
    docsExpired: "истёк срок документов",
    cdl: "CDL истекает в течение 30 дней",
    cdlOne: "CDL истекает через {{days}} дн.",
    carrier: "ответ перевозчика задерживается 3+ дня",
    stale: "водители {{days}}+ дней на одном этапе",
    overdue: "просроченных напоминаний у рекрутеров",
    quiet: "рекрутеров молчат {{days}}+ дня",
    approvals: "согласований ждут вашего решения",
    allClear: "Всё в порядке — сейчас ничего не требует внимания.",
    andMore_one: "и ещё {{count}}",
    andMore_few: "и ещё {{count}}",
    andMore_many: "и ещё {{count}}",
    andMore_other: "и ещё {{count}}",
  },
  pipeline: {
    title: "Моя воронка",
    branch: "Воронка",
    active_one: "{{count}} активный",
    active_few: "{{count}} активных",
    active_many: "{{count}} активных",
    active_other: "{{count}} активных",
    board: "Открыть доску",
    empty: "Активных водителей пока нет.",
  },
  recent: { title: "Недавно обновлённые", all: "Все водители", empty: "Водителей пока нет. Добавьте первого." },
  leader: {
    sub: "{{month}} · наймы",
    you: "(вы)",
    rank: "Вы {{pos}} из {{of}}",
    myPage: "Моя страница",
    top: "Лучшие рекрутеры",
    allPeople: "Все сотрудники",
    none: "В этом месяце подтверждённых наймов ещё нет.",
    without_one: "{{count}} рекрутер пока без найма",
    without_few: "{{count}} рекрутера пока без найма",
    without_many: "{{count}} рекрутеров пока без найма",
    without_other: "{{count}} рекрутера пока без найма",
    hires_one: "{{count}} найм",
    hires_few: "{{count}} найма",
    hires_many: "{{count}} наймов",
    hires_other: "{{count}} найма",
  },
  company: {
    title: "Пульс компании",
    line: "День {{day}} из {{days}} · {{recruiters}} рекрутеров в {{branches}} филиалах · {{activities}} действий за неделю",
    lineBranch: "День {{day}} из {{days}} · {{recruiters}} рекрутеров · {{activities}} действий за неделю",
  },
  branches: {
    title: "Филиалы",
    compare: "Сравнить в отчётах",
    rowHint: "Клик по строке — этот филиал",
    back: "Все филиалы",
    cols: { branch: "Филиал", recruiters: "Рекрутеры", new: "Новые", submitted: "Отправлено", hired: "Нанято", retention: "Удержание", pipeline: "В воронке" },
  },
  months: { title: "Наймы", sub_one: "последние 12 месяцев · всего {{count}}", sub_few: "последние 12 месяцев · всего {{count}}", sub_many: "последние 12 месяцев · всего {{count}}", sub_other: "последние 12 месяцев · всего {{count}}", trends: "Тренды" },
  weeks: { title: "Наймы по неделям", sub: "подтверждённые · 8 недель" },
  money: {
    title: "Деньги",
    sub: "{{month}} · USD",
    finance: "Финансы",
    expected: "Ожидается",
    received: "Получено",
    cost: "Расходы",
    profit: "Прибыль",
    noFees_one: "Оплата перевозчика за {{count}} найм в {{month}} не внесена",
    noFees_few: "Оплаты перевозчиков за {{count}} найма в {{month}} не внесены",
    noFees_many: "Оплаты перевозчиков за {{count}} наймов в {{month}} не внесены",
    noFees_other: "Оплаты перевозчиков за {{count}} найма в {{month}} не внесены",
  },
  funnel: { title: "Воронка", sub: "{{month}} · % от предыдущего шага", lost_one: "Потеряно {{count}}", lost_few: "Потеряно {{count}}", lost_many: "Потеряно {{count}}", lost_other: "Потеряно {{count}}" },
  manager: {
    line: "{{scope}} · {{recruiters}} рекрутеров · {{approvals}} · {{overdue}}",
    approvalsWaiting_one: "{{count}} согласование ждёт",
    approvalsWaiting_few: "{{count}} согласования ждут",
    approvalsWaiting_many: "{{count}} согласований ждут",
    approvalsWaiting_other: "{{count}} согласования ждут",
    tasksOverdue_one: "{{count}} ваша задача просрочена",
    tasksOverdue_few: "{{count}} ваши задачи просрочены",
    tasksOverdue_many: "{{count}} ваших задач просрочено",
    tasksOverdue_other: "{{count}} ваших задач просрочено",
    teamTitle: "Команда сегодня",
    team: "Команда",
    teamSub: "{{active}} сейчас активны · {{quiet}} молчат на этой неделе",
    cols: { recruiter: "Рекрутер", callsToday: "Звонков сегодня", submitted: "Отправлено", hired: "Нанято", last: "Последняя активность" },
    quietDays_one: "Молчит {{count}} день",
    quietDays_few: "Молчит {{count}} дня",
    quietDays_many: "Молчит {{count}} дней",
    quietDays_other: "Молчит {{count}} дня",
    never: "Активности ещё нет",
    more_one: "ещё {{count}} рекрутер",
    more_few: "ещё {{count}} рекрутера",
    more_many: "ещё {{count}} рекрутеров",
    more_other: "ещё {{count}} рекрутера",
    showAll: "Показать всех",
    noRecruiters: "В этой области пока нет рекрутеров.",
    approvals: "Согласования",
    waiting_one: "{{count}} ждёт",
    waiting_few: "{{count}} ждут",
    waiting_many: "{{count}} ждут",
    waiting_other: "{{count}} ждут",
    reviewAll: "Открыть все",
    openDriver: "Открыть водителя",
    approve: "Подтвердить",
    reject: "Отклонить…",
    approved: "Подтверждено: {{name}}",
    approveFailed: "Не удалось подтвердить",
    noApprovals: "Нет запросов, ожидающих вашего решения.",
    recruiters: "Рекрутеры",
    recruitersSub: "{{month}} · клик по строке — страница сотрудника",
    reports: "Отчёты",
    cols2: { new: "Новые", contacted: "Связались", submitted: "Отправлено", hired: "Нанято", conv: "Конв.", days: "Ср. дней", recruiters: "Рекрутеры", retention: "Удержание" },
    myDrivers: "Мои водители",
  },
};
